<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Fale Conosco
    </h1>
</header>
<main class="main__content">
    <!-- <h2>Tem alguma dúvida?</h2> -->
    <section class="content__cards">
        <div class="card">
            <header class="card__header">
                <fa-icon [icon]="faEnvelope" size="2x" class="card__header__icon"></fa-icon>
                <a class="card__content__contato" href="mailto:fundacao@fcopel.org.br?subject=Duvida%20atendimento">
                    <h3 class="card__header__title">E-mail</h3>
                </a>
            </header>
            <main class="card__content">
                <!-- hr -->
                <p>Segunda a Sexta feira das 08:00 às 18:00.</p>
                <a class="card__content__contato" href="mailto:fundacao@fcopel.org.br?subject=Duvida%20atendimento">
                    <p class="card__content__contato">E-mail: fundacao@fcopel.org.br</p>
                </a>
            </main>
        </div>
        <div class="card">
            <header class="card__header">
                <fa-icon [icon]="faPhone" size="2x" class="card__header__icon"></fa-icon>
                <a class="card__content__contato" href="tel:+4138836177">
                    <h3 class="card__header__title">Telefone</h3>
                </a>
            </header>
            <main class="card__content">
                <p>Segunda a Sexta feira das 08:00 às 18:00.</p>
                <a class="card__content__contato" href="tel:+08006020225">
                    <p class="card__content__contato">Agente Regional: 0800 602 0225</p>
                </a>
                <a class="card__content__contato" href="tel:+4138836177">
                    <p class="card__content__contato">Telefone: (41) 3883-6177</p>
                </a>
            </main>
        </div>
        <div class="card">
            <header class="card__header">
                <fa-icon [icon]="faEye" size="2x" class="card__header__icon"></fa-icon>
                <a class="card__content__contato" target="_blank"
                    href="https://api.whatsapp.com/send?phone=41991038616">
                    <h3 class="card__header__title">WhatsApp</h3>
                </a>
            </header>
            <main class="card__content">
                <p>Atendimento agilizado.</p>
                <a class="card__content__contato" target="_blank"
                    href="https://api.whatsapp.com/send?phone=41991038616">
                    <p class="card__content__contato">Telefone: (41) 99103-8616</p>
                </a>
            </main>
        </div>
        <div class="card">
            <header class="card__header">
                <fa-icon [icon]="faStarOfLife" size="2x" class="card__header__icon"></fa-icon>
                <a class="card__content__contato" href="tel:+4138836010">
                    <h3 class="card__header__title">Emergência</h3>
                </a>
            </header>
            <main class="card__content">
                <p>Em caso de emergência, nos horários fora do expediente, finais de semana e feriados.</p>
                <a class="card__content__contato" href="tel:+4138836010">
                    <p class="card__content__contato">Telefone: (41) 3883-6010</p>
                </a>
            </main>
        </div>
    </section>
</main>
<footer>
</footer>